import heroSection from "../components/heroSection/locals/ar.json";
import aboutSection from "../components/aboutSection/locals/ar.json";
import serviceSection from "../components/serviceSection/locals/ar.json";
import numbersSection from "../components/numbersSection/locals/ar.json";
import reviewsSection from "../components/reviewsSection/locals/ar.json";
import newsSection from "../components/newsSection/locals/ar.json";

export default {
  heroSection,
  aboutSection,
  serviceSection,
  numbersSection,
  reviewsSection,
  newsSection,
};